import type { BrandPalette } from '../../types/manifest.js';

export function logoPrompt(
  companyName: string,
  hints?: string,
  palette?: BrandPalette,
): string {
  const colorClause = palette
    ? `Use these exact brand colors: primary "${palette.primary}", accent "${palette.accent}". The logo's main color is the primary; accents and secondary marks use the accent color. Do not use any colors outside this palette except clean white or black for fine details.`
    : '';
  const baseInstruction =
    `A clean, professional vector-style logo for "${companyName}". ` +
    `Square 1:1 composition. ` +
    `The logo MUST fill at least 95% of the image — no padding, no margin, no surrounding empty space. ` +
    `Transparent background. ` +
    `No tagline. No background imagery. No frame around the logo.`;
  return [baseInstruction, colorClause, hints ?? ''].filter(Boolean).join(' ');
}
